import checkIcon from "../../images/blog/arrow.png";
import thumb1 from "../../images/blog/roadmap-img.png";
import thumb2 from "../../images/blog/roadmap-img2.png"; 
import thumb3 from "../../images/blog/roadmap-img3.png";
import thumb4 from "../../images/blog/roadmap-img4.png";
import thumb5 from "../../images/blog/roadmap-img5.png";
const data = [
  {
    progressIcon: checkIcon,
    progress: "10",
    title: "Launch The Website",
    text: "The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced.",
    thumb: thumb1,
  },
  {
    progressIcon: checkIcon,
    progress: "20",
    title: "Giveaway to Holders",
    text: "The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced.",
    thumb: thumb2,
  },
  {
    progressIcon: checkIcon,
    progress: "50",
    title: "Pre-sale Start",
    text: "The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced.",
    thumb: thumb3,
  },
  {
    progressIcon: checkIcon,
    progress: "75",
    title: "Legendary Guest Artist Backgrounds",
    text: "The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced.",
    thumb: thumb4,
  },
  {
    progressIcon: checkIcon,
    progress: "100",
    title: "Personalize Your NFT",
    text: "The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from de Finibus Bonorum et Malorum by Cicero are also reproduced.",
    thumb: thumb5,
  },
];

export default data;
